import {
  BetaFeature,
  UnblockerType,
  Whitelist
} from "@tvg/sh-lib-beta-program/types";
import { BetaFeatures, BetaFeature as StoryblokBetaFeature } from "../types";

export const betaFeatureMock = {
  description: {
    type: "doc",
    content: [
      {
        type: "paragraph",
        content: [
          {
            text: "We've been building a brand new My Stable, and we'd love to hear what you think!",
            type: "text"
          }
        ]
      },
      {
        type: "paragraph"
      },
      {
        type: "paragraph",
        content: [
          {
            text: "This new page features updates to:",
            type: "text"
          }
        ]
      },
      {
        type: "bullet_list",
        content: [
          {
            type: "list_item",
            content: [
              {
                type: "paragraph",
                content: [
                  {
                    text: "Notes",
                    type: "text"
                  }
                ]
              }
            ]
          },
          {
            type: "list_item",
            content: [
              {
                type: "paragraph",
                content: [
                  {
                    text: "Add to My Stable",
                    type: "text"
                  }
                ]
              }
            ]
          },
          {
            type: "list_item",
            content: [
              {
                type: "paragraph",
                content: [
                  {
                    text: "Running Today",
                    type: "text"
                  }
                ]
              }
            ]
          },
          {
            type: "list_item",
            content: [
              {
                type: "paragraph",
                content: [
                  {
                    text: "Search Horses",
                    type: "text"
                  }
                ]
              },
              {
                type: "paragraph"
              }
            ]
          }
        ]
      },
      {
        type: "heading",
        attrs: {
          level: 2
        },
        content: [
          {
            text: "Interested in testing it out?",
            type: "text"
          }
        ]
      },
      {
        type: "paragraph",
        content: [
          {
            text: "You can opt-out at any time.",
            type: "text"
          }
        ]
      }
    ]
  },
  details: [
    {
      _uid: "80968d0c-fa01-44f3-9172-6646cc7aa3bb",
      list: [
        {
          _uid: "5d71e7f8-960e-4675-b572-79264c6a982e",
          icon: "success",
          text: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                content: [
                  {
                    text: "Ability to add a note in a Horse.",
                    type: "text"
                  }
                ]
              }
            ]
          },
          title: "Notes",
          component: "Beta Feature Details Item List",
          _editable:
            '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "5d71e7f8-960e-4675-b572-79264c6a982e", "id": "341442685"}-->'
        },
        {
          _uid: "90a7ec4a-e4dd-49e2-be6d-50af08f4430f",
          icon: "success",
          text: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                content: [
                  {
                    text: "Ability to add an entity to user stable or remove the entity from user stable.",
                    type: "text"
                  }
                ]
              }
            ]
          },
          title: "Add to My Stable",
          component: "Beta Feature Details Item List",
          _editable:
            '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "90a7ec4a-e4dd-49e2-be6d-50af08f4430f", "id": "341442685"}-->'
        },
        {
          _uid: "6538b42e-c5bc-4440-89d8-3eb4cab47888",
          icon: "success",
          text: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                content: [
                  {
                    text: "Search any Entity in TVG database",
                    type: "text"
                  }
                ]
              }
            ]
          },
          title: "Running Today",
          component: "Beta Feature Details Item List",
          _editable:
            '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "6538b42e-c5bc-4440-89d8-3eb4cab47888", "id": "341442685"}-->'
        },
        {
          _uid: "ea6370f5-9203-404c-b085-54b33d3e2539",
          icon: "success",
          text: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                content: [
                  {
                    text: "Display all entities that are running or have results today.",
                    type: "text"
                  }
                ]
              }
            ]
          },
          title: "Search Horses",
          component: "Beta Feature Details Item List",
          _editable:
            '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "ea6370f5-9203-404c-b085-54b33d3e2539", "id": "341442685"}-->'
        }
      ],
      component: "Beta Feature Details",
      description: "",
      _editable:
        '<!--#storyblok#{"name": "Beta Feature Details", "space": "75080", "uid": "80968d0c-fa01-44f3-9172-6646cc7aa3bb", "id": "341442685"}-->'
    }
  ]
};

export const betaFeaturesMock = {
  name: "Beta Features Menu",
  created_at: "2023-07-17T19:27:47.147Z",
  published_at: null,
  alternates: [],
  id: 341148690,
  uuid: "3c446f30-73e3-47ca-9b85-4430423f7f3a",
  content: {
    _uid: "8dd6794f-69a8-435f-b237-2a5e54aef085",
    features: [
      {
        _uid: "bfa7f4f7-5c8d-44cd-a28d-59012f48e371",
        link: {
          id: "2ab5f398-9493-416f-9fbc-0574544bc0c7",
          url: "",
          linktype: "story",
          fieldtype: "multilink",
          cached_url: "beta-program/features/programPage",
          story: {
            name: "Program Page",
            created_at: "2023-07-10T15:08:19.356Z",
            published_at: "2023-07-26T11:38:16.568Z",
            alternates: [],
            id: 338625786,
            uuid: "2ab5f398-9493-416f-9fbc-0574544bc0c7",
            content: {
              _uid: "e5b14760-edd7-4439-8351-179d1aa8c761",
              component: "betaProgramFeature",
              exit_title: "Exit Program Page",
              welcome_title: "New Race Page Beta Feature",
              enroll_details: [],
              unroll_details: [],
              exit_description: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Are you sure you want leave beta Program?",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              welcome_subtitle: "BETA",
              enroll_description: {
                type: "doc",
                content: [
                  {
                    type: "heading",
                    attrs: {
                      level: 2
                    },
                    content: [
                      {
                        text: "2 New Race Page Beta Feature",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "We've been building a brand new Program Page, and we'd love to hear what you think!",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph"
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "The new Race Page allows you to:",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "bullet_list",
                    content: [
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Access every runner's PP’s, race replays and stats directly in the race card",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "View pools, will pays, probables and active bets for each race",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Check out a new & improved Featured & Scheduled Races section on the left-hand navigation",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Get expert picks from TrackMaster, Timeform, R&S and numberFire",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Place straight, exotic, and pick bets",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Watch races live",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "paragraph"
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Coming soon:",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "bullet_list",
                    content: [
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "FanDuel TV Picks",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Daily Double probables table fix",
                                type: "text"
                              }
                            ]
                          },
                          {
                            type: "paragraph"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "heading",
                    attrs: {
                      level: 2
                    },
                    content: [
                      {
                        text: "Interested in testing it out?",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "You can opt-out at any time and return to the original Race Page. To do so, navigate to the 'Your Account' section and click 'Features Preview'.",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              unroll_description: {
                type: "doc",
                content: [
                  {
                    type: "heading",
                    attrs: {
                      level: 2
                    },
                    content: [
                      {
                        text: "New Race Page Beta Feature",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "We've been building a brand new Program Page, and we'd love to hear what you think!",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph"
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "The new Race Page allows you to:",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "bullet_list",
                    content: [
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Access every runner's PP’s, race replays and stats directly in the race card",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "View pools, will pays, probables and active bets for each race",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Check out a new & improved Featured & Scheduled Races section on the left-hand navigation",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Get expert picks from TrackMaster, Timeform, R&S and numberFire",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Place straight, exotic, and pick bets",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Watch races live",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "paragraph"
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Coming soon:",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "bullet_list",
                    content: [
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "FanDuel TV Picks",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Daily Double probables table fix",
                                type: "text"
                              }
                            ]
                          },
                          {
                            type: "paragraph"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "heading",
                    attrs: {
                      level: 2
                    },
                    content: [
                      {
                        text: "Interested in testing it out?",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "You can opt-out at any time and return to the original Race Page. To do so, navigate to the 'Your Account' section and click 'Features Preview'.",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              welcome_description: {
                type: "doc",
                content: [
                  {
                    type: "heading",
                    attrs: {
                      level: 2
                    },
                    content: [
                      {
                        text: "New Race Page Beta",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Welcome to the new TVG Race Page",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "All of the great features you love on TVG just got even better! Explore our new Race Page experience and let us know what you think via the “Feedback” button on the right-hand side of the page!",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              _editable:
                '<!--#storyblok#{"name": "betaProgramFeature", "space": "75080", "uid": "e5b14760-edd7-4439-8351-179d1aa8c761", "id": "338625786"}-->'
            },
            slug: "programPage",
            full_slug: "beta-program/features/programPage",
            default_full_slug: null,
            sort_by_date: null,
            position: 0,
            tag_list: [],
            is_startpage: false,
            parent_id: 338625779,
            meta_data: null,
            group_id: "657b01de-2936-4494-ad24-39d5db57bc90",
            first_published_at: "2023-07-26T11:38:16.568Z",
            release_id: null,
            lang: "default",
            path: null,
            translated_slugs: []
          }
        },
        name: "Program Page",
        component: "Beta Feature",
        _editable:
          '<!--#storyblok#{"name": "Beta Feature", "space": "75080", "uid": "bfa7f4f7-5c8d-44cd-a28d-59012f48e371", "id": "341148690"}-->'
      },
      {
        _uid: "6597d6f3-dcb5-45db-ad77-425948758f12",
        link: {
          id: "58237620-0a33-422d-8333-f9baee7d192f",
          url: "",
          linktype: "story",
          fieldtype: "multilink",
          cached_url: "beta-program/features/myStable",
          story: {
            name: "My Stable",
            created_at: "2023-07-18T12:11:41.022Z",
            published_at: null,
            alternates: [],
            id: 341442685,
            uuid: "58237620-0a33-422d-8333-f9baee7d192f",
            content: {
              _uid: "246d3b0f-dbe1-48e8-bd59-48bbf0d2d7bd",
              component: "betaProgramFeature",
              welcome_title: "Welcome",
              enroll_details: [
                {
                  _uid: "80968d0c-fa01-44f3-9172-6646cc7aa3bb",
                  list: [
                    {
                      _uid: "5d71e7f8-960e-4675-b572-79264c6a982e",
                      icon: "success",
                      text: {
                        type: "doc",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Ability to add a note in a Horse.",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      title: "Notes",
                      component: "Beta Feature Details Item List",
                      _editable:
                        '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "5d71e7f8-960e-4675-b572-79264c6a982e", "id": "341442685"}-->'
                    },
                    {
                      _uid: "90a7ec4a-e4dd-49e2-be6d-50af08f4430f",
                      icon: "success",
                      text: {
                        type: "doc",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Ability to add an entity to user stable or remove the entity from user stable.",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      title: "Add to My Stable",
                      component: "Beta Feature Details Item List",
                      _editable:
                        '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "90a7ec4a-e4dd-49e2-be6d-50af08f4430f", "id": "341442685"}-->'
                    },
                    {
                      _uid: "6538b42e-c5bc-4440-89d8-3eb4cab47888",
                      icon: "success",
                      text: {
                        type: "doc",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Search any Entity in TVG database",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      title: "Running Today",
                      component: "Beta Feature Details Item List",
                      _editable:
                        '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "6538b42e-c5bc-4440-89d8-3eb4cab47888", "id": "341442685"}-->'
                    },
                    {
                      _uid: "ea6370f5-9203-404c-b085-54b33d3e2539",
                      icon: "success",
                      text: {
                        type: "doc",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Display all entities that are running or have results today.",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      title: "Search Horses",
                      component: "Beta Feature Details Item List",
                      _editable:
                        '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "ea6370f5-9203-404c-b085-54b33d3e2539", "id": "341442685"}-->'
                    }
                  ],
                  component: "Beta Feature Details",
                  description: "",
                  _editable:
                    '<!--#storyblok#{"name": "Beta Feature Details", "space": "75080", "uid": "80968d0c-fa01-44f3-9172-6646cc7aa3bb", "id": "341442685"}-->'
                }
              ],
              unroll_details: [
                {
                  _uid: "d6924351-cb51-4c4a-8c52-63468a54ca8e",
                  component: "Beta Feature Details",
                  _editable:
                    '<!--#storyblok#{"name": "Beta Feature Details", "space": "75080", "uid": "d6924351-cb51-4c4a-8c52-63468a54ca8e", "id": "341442685"}-->'
                }
              ],
              welcome_subtitle: "Sub Welcome",
              enroll_description: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "We've been building a brand new My Stable, and we'd love to hear what you think!",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph"
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "This new page features updates to:",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "bullet_list",
                    content: [
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Notes",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Add to My Stable",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Running Today",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Search Horses",
                                type: "text"
                              }
                            ]
                          },
                          {
                            type: "paragraph"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "heading",
                    attrs: {
                      level: 2
                    },
                    content: [
                      {
                        text: "Interested in testing it out?",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "You can opt-out at any time.",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              unroll_description: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "We've been building a brand new My Stable, and we'd love to hear what you think!",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "This new page features updates to:",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "bullet_list",
                    content: [
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Notes",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Add to My Stable",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Running Today",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        type: "list_item",
                        content: [
                          {
                            type: "paragraph",
                            content: [
                              {
                                text: "Search Horses",
                                type: "text"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    type: "heading",
                    attrs: {
                      level: 2
                    },
                    content: [
                      {
                        text: "Interested in testing it out?",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "You can opt-out at any time.",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              welcome_description: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Text Welcome",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              _editable:
                '<!--#storyblok#{"name": "betaProgramFeature", "space": "75080", "uid": "246d3b0f-dbe1-48e8-bd59-48bbf0d2d7bd", "id": "341442685"}-->'
            },
            slug: "myStable",
            full_slug: "beta-program/features/myStable",
            default_full_slug: null,
            sort_by_date: null,
            position: -10,
            tag_list: [],
            is_startpage: false,
            parent_id: 338625779,
            meta_data: null,
            group_id: "9280d36e-a2ba-41dd-aa7b-c61a8b76615c",
            first_published_at: null,
            release_id: null,
            lang: "default",
            path: null,
            translated_slugs: []
          }
        },
        name: "My Stable",
        component: "Beta Feature",
        _editable:
          '<!--#storyblok#{"name": "Beta Feature", "space": "75080", "uid": "6597d6f3-dcb5-45db-ad77-425948758f12", "id": "341148690"}-->'
      }
    ],
    component: "beta_features_menu",
    _editable:
      '<!--#storyblok#{"name": "beta_features_menu", "space": "75080", "uid": "8dd6794f-69a8-435f-b237-2a5e54aef085", "id": "341148690"}-->'
  },
  slug: "beta-program",
  full_slug: "beta-program/",
  default_full_slug: null,
  sort_by_date: null,
  position: -20,
  tag_list: [],
  is_startpage: true,
  parent_id: 288092078,
  meta_data: null,
  group_id: "7054323b-d2f5-441c-bc8f-e2d5e75f12b7",
  first_published_at: null,
  release_id: null,
  lang: "default",
  path: null,
  translated_slugs: []
};

export const betaFeaturesFormattedMock = {
  programPage: {
    name: "Program Page",
    enroll: {
      description: {
        type: "doc",
        content: [
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "2 New Race Page Beta Feature",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "We've been building a brand new Program Page, and we'd love to hear what you think!",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph"
          },
          {
            type: "paragraph",
            content: [
              {
                text: "The new Race Page allows you to:",
                type: "text"
              }
            ]
          },
          {
            type: "bullet_list",
            content: [
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Access every runner's PP’s, race replays and stats directly in the race card",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "View pools, will pays, probables and active bets for each race",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Check out a new & improved Featured & Scheduled Races section on the left-hand navigation",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Get expert picks from TrackMaster, Timeform, R&S and numberFire",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Place straight, exotic, and pick bets",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Watch races live",
                        type: "text"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "paragraph"
          },
          {
            type: "paragraph",
            content: [
              {
                text: "Coming soon:",
                type: "text"
              }
            ]
          },
          {
            type: "bullet_list",
            content: [
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "FanDuel TV Picks",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Daily Double probables table fix",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph"
                  }
                ]
              }
            ]
          },
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "Interested in testing it out?",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "You can opt-out at any time and return to the original Race Page. To do so, navigate to the 'Your Account' section and click 'Features Preview'.",
                type: "text"
              }
            ]
          }
        ]
      },
      details: []
    },
    unroll: {
      description: {
        type: "doc",
        content: [
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "New Race Page Beta Feature",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "We've been building a brand new Program Page, and we'd love to hear what you think!",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph"
          },
          {
            type: "paragraph",
            content: [
              {
                text: "The new Race Page allows you to:",
                type: "text"
              }
            ]
          },
          {
            type: "bullet_list",
            content: [
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Access every runner's PP’s, race replays and stats directly in the race card",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "View pools, will pays, probables and active bets for each race",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Check out a new & improved Featured & Scheduled Races section on the left-hand navigation",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Get expert picks from TrackMaster, Timeform, R&S and numberFire",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Place straight, exotic, and pick bets",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Watch races live",
                        type: "text"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "paragraph"
          },
          {
            type: "paragraph",
            content: [
              {
                text: "Coming soon:",
                type: "text"
              }
            ]
          },
          {
            type: "bullet_list",
            content: [
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "FanDuel TV Picks",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Daily Double probables table fix",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph"
                  }
                ]
              }
            ]
          },
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "Interested in testing it out?",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "You can opt-out at any time and return to the original Race Page. To do so, navigate to the 'Your Account' section and click 'Features Preview'.",
                type: "text"
              }
            ]
          }
        ]
      },
      details: []
    },
    welcome: {
      description: {
        type: "doc",
        content: [
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "New Race Page Beta",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "Welcome to the new TVG Race Page",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "All of the great features you love on TVG just got even better! Explore our new Race Page experience and let us know what you think via the “Feedback” button on the right-hand side of the page!",
                type: "text"
              }
            ]
          }
        ]
      },
      title: "New Race Page Beta Feature",
      subtitle: "BETA"
    },
    exit: {
      description: {
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                text: "Are you sure you want leave beta Program?",
                type: "text"
              }
            ]
          }
        ]
      },
      title: "Exit Program Page"
    }
  },
  myStable: {
    name: "My Stable",
    enroll: {
      description: {
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                text: "We've been building a brand new My Stable, and we'd love to hear what you think!",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph"
          },
          {
            type: "paragraph",
            content: [
              {
                text: "This new page features updates to:",
                type: "text"
              }
            ]
          },
          {
            type: "bullet_list",
            content: [
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Notes",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Add to My Stable",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Running Today",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Search Horses",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph"
                  }
                ]
              }
            ]
          },
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "Interested in testing it out?",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "You can opt-out at any time.",
                type: "text"
              }
            ]
          }
        ]
      },
      details: [
        {
          _uid: "80968d0c-fa01-44f3-9172-6646cc7aa3bb",
          list: [
            {
              _uid: "5d71e7f8-960e-4675-b572-79264c6a982e",
              icon: "success",
              text: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Ability to add a note in a Horse.",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              title: "Notes",
              component: "Beta Feature Details Item List",
              _editable:
                '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "5d71e7f8-960e-4675-b572-79264c6a982e", "id": "341442685"}-->'
            },
            {
              _uid: "90a7ec4a-e4dd-49e2-be6d-50af08f4430f",
              icon: "success",
              text: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Ability to add an entity to user stable or remove the entity from user stable.",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              title: "Add to My Stable",
              component: "Beta Feature Details Item List",
              _editable:
                '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "90a7ec4a-e4dd-49e2-be6d-50af08f4430f", "id": "341442685"}-->'
            },
            {
              _uid: "6538b42e-c5bc-4440-89d8-3eb4cab47888",
              icon: "success",
              text: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Search any Entity in TVG database",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              title: "Running Today",
              component: "Beta Feature Details Item List",
              _editable:
                '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "6538b42e-c5bc-4440-89d8-3eb4cab47888", "id": "341442685"}-->'
            },
            {
              _uid: "ea6370f5-9203-404c-b085-54b33d3e2539",
              icon: "success",
              text: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Display all entities that are running or have results today.",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              title: "Search Horses",
              component: "Beta Feature Details Item List",
              _editable:
                '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "ea6370f5-9203-404c-b085-54b33d3e2539", "id": "341442685"}-->'
            }
          ],
          component: "Beta Feature Details",
          description: "",
          _editable:
            '<!--#storyblok#{"name": "Beta Feature Details", "space": "75080", "uid": "80968d0c-fa01-44f3-9172-6646cc7aa3bb", "id": "341442685"}-->'
        }
      ]
    },
    unroll: {
      description: {
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                text: "We've been building a brand new My Stable, and we'd love to hear what you think!",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "This new page features updates to:",
                type: "text"
              }
            ]
          },
          {
            type: "bullet_list",
            content: [
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Notes",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Add to My Stable",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Running Today",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Search Horses",
                        type: "text"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "Interested in testing it out?",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "You can opt-out at any time.",
                type: "text"
              }
            ]
          }
        ]
      },
      details: [
        {
          _uid: "d6924351-cb51-4c4a-8c52-63468a54ca8e",
          component: "Beta Feature Details",
          _editable:
            '<!--#storyblok#{"name": "Beta Feature Details", "space": "75080", "uid": "d6924351-cb51-4c4a-8c52-63468a54ca8e", "id": "341442685"}-->'
        }
      ]
    },
    welcome: {
      description: {
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                text: "Text Welcome",
                type: "text"
              }
            ]
          }
        ]
      },
      title: "Welcome",
      subtitle: "Sub Welcome"
    },
    exit: {}
  }
};

export const whitelistConfigMock: Array<Whitelist> = [
  {
    id: BetaFeature.PROGRAM_PAGE,
    unblockerType: UnblockerType.COOKIE,
    unblocker: "useTvg5=true",
    contentId: "betaProgramContent",
    usersWhitelist: [
      "365767",
      "346799",
      "937346",
      "931250",
      "2275040",
      "338037",
      "615",
      "338442",
      "355632",
      "355597",
      "423706",
      "572",
      "1026256"
    ],
    unenrollCooldownMinutes: "1",
    dismissCooldownMinutes: "1",
    maybeLaterCooldownMinutes: "5"
  },
  {
    id: BetaFeature.MY_STABLE,
    unblockerType: UnblockerType.COOKIE,
    unblocker: "useNewMyStable=true",
    contentId: "myStableContent",
    usersWhitelist: ["937346", "931250", "1026256"],
    unenrollCooldownMinutes: "5",
    dismissCooldownMinutes: "1",
    maybeLaterCooldownMinutes: "10"
  }
];

export const betaFeatureFormattedMock: BetaFeatures = {
  programPage: {
    name: "Program Page",
    enroll: {
      description: {
        // @ts-ignore
        type: "doc",
        content: [
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "2 New Race Page Beta Feature",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "We've been building a brand new Program Page, and we'd love to hear what you think!",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph"
          },
          {
            type: "paragraph",
            content: [
              {
                text: "The new Race Page allows you to:",
                type: "text"
              }
            ]
          },
          {
            type: "bullet_list",
            content: [
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Access every runner's PP’s, race replays and stats directly in the race card",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "View pools, will pays, probables and active bets for each race",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Check out a new & improved Featured & Scheduled Races section on the left-hand navigation",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Get expert picks from TrackMaster, Timeform, R&S and numberFire",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Place straight, exotic, and pick bets",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Watch races live",
                        type: "text"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "paragraph"
          },
          {
            type: "paragraph",
            content: [
              {
                text: "Coming soon:",
                type: "text"
              }
            ]
          },
          {
            type: "bullet_list",
            content: [
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "FanDuel TV Picks",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Daily Double probables table fix",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph"
                  }
                ]
              }
            ]
          },
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "Interested in testing it out?",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "You can opt-out at any time and return to the original Race Page. To do so, navigate to the 'Your Account' section and click 'Features Preview'.",
                type: "text"
              }
            ]
          }
        ]
      }
    },
    unroll: {
      description: {
        // @ts-ignore
        type: "doc",
        content: [
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "New Race Page Beta Feature",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "We've been building a brand new Program Page, and we'd love to hear what you think!",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph"
          },
          {
            type: "paragraph",
            content: [
              {
                text: "The new Race Page allows you to:",
                type: "text"
              }
            ]
          },
          {
            type: "bullet_list",
            content: [
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Access every runner's PP’s, race replays and stats directly in the race card",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "View pools, will pays, probables and active bets for each race",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Check out a new & improved Featured & Scheduled Races section on the left-hand navigation",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Get expert picks from TrackMaster, Timeform, R&S and numberFire",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Place straight, exotic, and pick bets",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Watch races live",
                        type: "text"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "paragraph"
          },
          {
            type: "paragraph",
            content: [
              {
                text: "Coming soon:",
                type: "text"
              }
            ]
          },
          {
            type: "bullet_list",
            content: [
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "FanDuel TV Picks",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Daily Double probables table fix",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph"
                  }
                ]
              }
            ]
          },
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "Interested in testing it out?",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "You can opt-out at any time and return to the original Race Page. To do so, navigate to the 'Your Account' section and click 'Features Preview'.",
                type: "text"
              }
            ]
          }
        ]
      }
    },
    welcome: {
      description: {
        // @ts-ignore
        type: "doc",
        content: [
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "New Race Page Beta",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "Welcome to the new TVG Race Page",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "All of the great features you love on TVG just got even better! Explore our new Race Page experience and let us know what you think via the “Feedback” button on the right-hand side of the page!",
                type: "text"
              }
            ]
          }
        ]
      },
      title: "New Race Page Beta Feature",
      subtitle: "BETA"
    },
    exit: {}
  },
  myStable: {
    name: "My Stable",
    enroll: {
      description: {
        // @ts-ignore
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                text: "We've been building a brand new My Stable, and we'd love to hear what you think!",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph"
          },
          {
            type: "paragraph",
            content: [
              {
                text: "This new page features updates to:",
                type: "text"
              }
            ]
          },
          {
            type: "bullet_list",
            content: [
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Notes",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Add to My Stable",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Running Today",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Search Horses",
                        type: "text"
                      }
                    ]
                  },
                  {
                    type: "paragraph"
                  }
                ]
              }
            ]
          },
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "Interested in testing it out?",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "You can opt-out at any time.",
                type: "text"
              }
            ]
          }
        ]
      },
      details: [
        {
          _uid: "80968d0c-fa01-44f3-9172-6646cc7aa3bb",
          list: [
            {
              _uid: "5d71e7f8-960e-4675-b572-79264c6a982e",
              icon: "success",
              text: {
                // @ts-ignore
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Ability to add a note in a Horse.",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              title: "Notes",
              component: "Beta Feature Details Item List",
              _editable:
                '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "5d71e7f8-960e-4675-b572-79264c6a982e", "id": "341442685"}-->'
            },
            {
              _uid: "90a7ec4a-e4dd-49e2-be6d-50af08f4430f",
              icon: "success",
              text: {
                // @ts-ignore
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Ability to add an entity to user stable or remove the entity from user stable.",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              title: "Add to My Stable",
              component: "Beta Feature Details Item List",
              _editable:
                '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "90a7ec4a-e4dd-49e2-be6d-50af08f4430f", "id": "341442685"}-->'
            },
            {
              _uid: "6538b42e-c5bc-4440-89d8-3eb4cab47888",
              icon: "success",
              text: {
                // @ts-ignore
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Search any Entity in TVG database",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              title: "Running Today",
              component: "Beta Feature Details Item List",
              _editable:
                '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "6538b42e-c5bc-4440-89d8-3eb4cab47888", "id": "341442685"}-->'
            },
            {
              _uid: "ea6370f5-9203-404c-b085-54b33d3e2539",
              icon: "success",
              text: {
                // @ts-ignore
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Display all entities that are running or have results today.",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              title: "Search Horses",
              component: "Beta Feature Details Item List",
              _editable:
                '<!--#storyblok#{"name": "Beta Feature Details Item List", "space": "75080", "uid": "ea6370f5-9203-404c-b085-54b33d3e2539", "id": "341442685"}-->'
            }
          ],
          component: "Beta Feature Details",
          // @ts-ignore
          description: "",
          _editable:
            '<!--#storyblok#{"name": "Beta Feature Details", "space": "75080", "uid": "80968d0c-fa01-44f3-9172-6646cc7aa3bb", "id": "341442685"}-->'
        }
      ]
    },
    unroll: {
      description: {
        // @ts-ignore
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                text: "We've been building a brand new My Stable, and we'd love to hear what you think!",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "This new page features updates to:",
                type: "text"
              }
            ]
          },
          {
            type: "bullet_list",
            content: [
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Notes",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Add to My Stable",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Running Today",
                        type: "text"
                      }
                    ]
                  }
                ]
              },
              {
                type: "list_item",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        text: "Search Horses",
                        type: "text"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "heading",
            attrs: {
              level: 2
            },
            content: [
              {
                text: "Interested in testing it out?",
                type: "text"
              }
            ]
          },
          {
            type: "paragraph",
            content: [
              {
                text: "You can opt-out at any time.",
                type: "text"
              }
            ]
          }
        ]
      },
      details: [
        {
          // @ts-ignore
          _uid: "d6924351-cb51-4c4a-8c52-63468a54ca8e",
          component: "Beta Feature Details",
          _editable:
            '<!--#storyblok#{"name": "Beta Feature Details", "space": "75080", "uid": "d6924351-cb51-4c4a-8c52-63468a54ca8e", "id": "341442685"}-->'
        }
      ]
    },
    welcome: {
      description: {
        // @ts-ignore
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                text: "Text Welcome",
                type: "text"
              }
            ]
          }
        ]
      },
      title: "Welcome",
      subtitle: "Sub Welcome"
    },
    exit: {}
  }
};

export const betaFeatureFormattedProgramPageMock: StoryblokBetaFeature = {
  name: "Program Page",
  enroll: {
    description: {
      // @ts-ignore
      type: "doc",
      content: [
        {
          type: "heading",
          attrs: {
            level: 2
          },
          content: [
            {
              text: "2 New Race Page Beta Feature",
              type: "text"
            }
          ]
        },
        {
          type: "paragraph",
          content: [
            {
              text: "We've been building a brand new Program Page, and we'd love to hear what you think!",
              type: "text"
            }
          ]
        },
        {
          type: "paragraph"
        },
        {
          type: "paragraph",
          content: [
            {
              text: "The new Race Page allows you to:",
              type: "text"
            }
          ]
        },
        {
          type: "bullet_list",
          content: [
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Access every runner's PP’s, race replays and stats directly in the race card",
                      type: "text"
                    }
                  ]
                }
              ]
            },
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "View pools, will pays, probables and active bets for each race",
                      type: "text"
                    }
                  ]
                }
              ]
            },
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Check out a new & improved Featured & Scheduled Races section on the left-hand navigation",
                      type: "text"
                    }
                  ]
                }
              ]
            },
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Get expert picks from TrackMaster, Timeform, R&S and numberFire",
                      type: "text"
                    }
                  ]
                }
              ]
            },
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Place straight, exotic, and pick bets",
                      type: "text"
                    }
                  ]
                }
              ]
            },
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Watch races live",
                      type: "text"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: "paragraph"
        },
        {
          type: "paragraph",
          content: [
            {
              text: "Coming soon:",
              type: "text"
            }
          ]
        },
        {
          type: "bullet_list",
          content: [
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "FanDuel TV Picks",
                      type: "text"
                    }
                  ]
                }
              ]
            },
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Daily Double probables table fix",
                      type: "text"
                    }
                  ]
                },
                {
                  type: "paragraph"
                }
              ]
            }
          ]
        },
        {
          type: "heading",
          attrs: {
            level: 2
          },
          content: [
            {
              text: "Interested in testing it out?",
              type: "text"
            }
          ]
        },
        {
          type: "paragraph",
          content: [
            {
              text: "You can opt-out at any time and return to the original Race Page. To do so, navigate to the 'Your Account' section and click 'Features Preview'.",
              type: "text"
            }
          ]
        }
      ]
    },
    details: []
  },
  unroll: {
    description: {
      // @ts-ignore
      type: "doc",
      content: [
        {
          type: "heading",
          attrs: {
            level: 2
          },
          content: [
            {
              text: "New Race Page Beta Feature",
              type: "text"
            }
          ]
        },
        {
          type: "paragraph",
          content: [
            {
              text: "We've been building a brand new Program Page, and we'd love to hear what you think!",
              type: "text"
            }
          ]
        },
        {
          type: "paragraph"
        },
        {
          type: "paragraph",
          content: [
            {
              text: "The new Race Page allows you to:",
              type: "text"
            }
          ]
        },
        {
          type: "bullet_list",
          content: [
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Access every runner's PP’s, race replays and stats directly in the race card",
                      type: "text"
                    }
                  ]
                }
              ]
            },
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "View pools, will pays, probables and active bets for each race",
                      type: "text"
                    }
                  ]
                }
              ]
            },
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Check out a new & improved Featured & Scheduled Races section on the left-hand navigation",
                      type: "text"
                    }
                  ]
                }
              ]
            },
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Get expert picks from TrackMaster, Timeform, R&S and numberFire",
                      type: "text"
                    }
                  ]
                }
              ]
            },
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Place straight, exotic, and pick bets",
                      type: "text"
                    }
                  ]
                }
              ]
            },
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Watch races live",
                      type: "text"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: "paragraph"
        },
        {
          type: "paragraph",
          content: [
            {
              text: "Coming soon:",
              type: "text"
            }
          ]
        },
        {
          type: "bullet_list",
          content: [
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "FanDuel TV Picks",
                      type: "text"
                    }
                  ]
                }
              ]
            },
            {
              type: "list_item",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Daily Double probables table fix",
                      type: "text"
                    }
                  ]
                },
                {
                  type: "paragraph"
                }
              ]
            }
          ]
        },
        {
          type: "heading",
          attrs: {
            level: 2
          },
          content: [
            {
              text: "Interested in testing it out?",
              type: "text"
            }
          ]
        },
        {
          type: "paragraph",
          content: [
            {
              text: "You can opt-out at any time and return to the original Race Page. To do so, navigate to the 'Your Account' section and click 'Features Preview'.",
              type: "text"
            }
          ]
        }
      ]
    },
    details: []
  },
  welcome: {
    description: {
      // @ts-ignore
      type: "doc",
      content: [
        {
          type: "heading",
          attrs: {
            level: 2
          },
          content: [
            {
              text: "New Race Page Beta",
              type: "text"
            }
          ]
        },
        {
          type: "paragraph",
          content: [
            {
              text: "Welcome to the new TVG Race Page",
              type: "text"
            }
          ]
        },
        {
          type: "paragraph",
          content: [
            {
              text: "All of the great features you love on TVG just got even better! Explore our new Race Page experience and let us know what you think via the “Feedback” button on the right-hand side of the page!",
              type: "text"
            }
          ]
        }
      ]
    },
    title: "New Race Page Beta Feature",
    subtitle: "BETA"
  },
  exit: {
    description: {
      // @ts-ignore
      type: "doc",
      content: [
        {
          type: "paragraph",
          content: [
            {
              text: "Are you sure you want leave beta Program?",
              type: "text"
            }
          ]
        }
      ]
    },
    title: "Exit Program Page"
  }
};

export const formattedBetaFeatureListMock = [
  {
    label: "Program Page",
    value: "programPage"
  },
  {
    label: "My Stable",
    value: "myStable"
  }
];
